import React, { useEffect, useState } from 'react';
import { useGetPublisherQuery } from '../../api/publisherApiSlice';
import { PublisherDashboardContainer } from '../../components/publisher/PublisherDashboardContainer';
import {FilterGroup} from "../../components/FilterButton";
import {useGetCurrentUserQuery} from "../../api/userApiSlice";
import { DateRangeFilterButton } from '../../components/DateRangeFilterButton';
import Title from '../../components/Title';

export const Publisher = () => {
  const { data: {publisherId} = {}, isSuccess: isCurrentUserSuccess } = useGetCurrentUserQuery()
  const { data: publisher, isSuccess } = useGetPublisherQuery({publisherId}, { skip: !publisherId })
  const [filter, setFilter] = useState({})

  if(!isSuccess ) { return (<></>) }

  return (
    <>
      <Title main={publisher.name} sub="Dashboard"/>
      <FilterGroup onChange={setFilter}>
        <DateRangeFilterButton
          startDate={publisher.start_date}
          endDate={publisher.end_date}
        />
      </FilterGroup>
      <PublisherDashboardContainer publisherId={publisherId} startDate={filter.startDate} endDate={filter.endDate} />
    </>
  )
}
